export default {"src":"/_next/static/media/atom_icon.ecd3428e.svg","height":46,"width":49,"blurWidth":0,"blurHeight":0};